import { $qs, $qsa } from '../utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper, { EffectFade, Pagination, Autoplay } from 'swiper';

gsap.registerPlugin(ScrollTrigger);



function steps() {
    const section = $qs('[data-name="admissions-process"]');
    const sidebar = $qs('[data-target="steps-sidebar"]');
    const sidebarSteps = $qsa('[data-target="sidebar-step"]');
    const steps = $qsa('[data-target="step"]');
    const allButtons = $qsa('a.button', section);
    const allKeyDates = $qsa('[data-target="key-date"]', section);

    // pin sidebar
    ScrollTrigger.create({
        trigger: section,
        pin: sidebar,
        pinSpacing: false,
        end: 'bottom bottom',
    });

    // change bg colour and active sidebar item when entering each step
    steps && [...steps].forEach(step => {

        const { id, colour, bgColour, textColour } = step.dataset;
        const thisKeyDate = $qs(`[data-target="key-date"][data-id="${id}"]`);

        ScrollTrigger.create({
            trigger: step,
            pin: false,
            scrub: false,
            start: 'top center',
            end: 'bottom center',
            onEnter: () => {
                section.className = section.className.replace(/\bbg-\S+/g, '');
                section.classList.add(bgColour);
                section.dataset.textColour = textColour;

                [...sidebarSteps].forEach(sidebarStep => sidebarStep.dataset.active = 'false');
                $qs(`[data-target="sidebar-step"][data-id="${id}"]`, sidebar).dataset.active = 'true';
                [...allKeyDates].forEach(keyDate => keyDate.dataset.active = 'false');
                if (thisKeyDate) thisKeyDate.dataset.active = 'true';
                [...allButtons].forEach(button => button.className = `button button-${colour} button-inverted`);

            },
            onEnterBack: () => {
                section.className = section.className.replace(/\bbg-\S+/g, '');
                section.classList.add(bgColour);
                section.dataset.textColour = textColour;
                
                [...sidebarSteps].forEach(sidebarStep => sidebarStep.dataset.active = 'false');
                $qs(`[data-target="sidebar-step"][data-id="${id}"]`, sidebar).dataset.active = 'true';
                [...allKeyDates].forEach(keyDate => keyDate.dataset.active = 'false');
                if (thisKeyDate) thisKeyDate.dataset.active = 'true';
                [...allButtons].forEach(button => button.className = `button button-${colour} button-inverted`);
            },
            // markers: true
        })
    });
}

function keyDatesSliders() {
    const keyDateSliderElements = $qsa('[data-target="key-dates-slider"]');
    
    if (!keyDateSliderElements) return;

    [...keyDateSliderElements].forEach(slider => {

        const swiper = new Swiper(slider, {
            modules: [EffectFade, Pagination, Autoplay],
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                enabled: false,
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            breakpoints: {
                1080: {
                    autoplay: {
                        enabled: true,
                        delay: 4000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }
                }
            }
        });
    });
}

function AdmissionsProcess() {
    if (!$qs('.page-template-tpl-admissions-process')) return;
    
    steps();
    keyDatesSliders();
}

export default AdmissionsProcess;